
import { cityStore } from '@/store';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LeadCardComponent extends Vue {
  @Prop(Object) readonly item;
  @Prop({ type: Boolean, default: true }) readonly clickable;

  public async abrir() {
    let lead_id = this.item.id;
    if (lead_id == '0') {
      return;
    }
    let routeData = this.$router.resolve({
      name: 'main-lead-edit',
      params: { id: lead_id },
    });
    window.open(routeData.href, '_blank');
  }

  public parcelaColors = [
    { id: 0, color: '#90EE90' },
    { id: 1, color: 'yellow' },
    { id: 2, color: '#FF7F7F' },
  ];

  public getColorLead(id) {
    switch (Number(id)) {
      case 1:
        return '#90EE90';
        break;
      case 2:
        return 'yellow';
        break;
      case 3:
        return '#FF7F7F';
        break;
      default:
        return 'light gray';
        break;
    }
  }

  get specialCities() {
    return cityStore.cities;
  }

  public getStatusParcela(parcela) {
    switch (true) {
      case parcela['Valor Pago'] === parcela['Valor original']:
        return 0;
      case new Date(parcela['Vencimento']) >= new Date():
        return 1;
      default:
        return 2;
    }
  }

  public getColorDate(d) {
    const date = new Date(d);
    const now = new Date();
    if (date > now) {
      return '#90EE90';
    } else {
      return '#FF7F7F';
    }
  }

  public getTipoLead(id) {
    switch (Number(id)) {
      case 1:
        return 'Professor';
        break;
      case 2:
        return 'Escola';
        break;
      case 3:
        return 'Investidor';
        break;
      case 4:
        return 'Franqueado';
        break;
      case 5:
        return 'Funcionário';
        break;
      case 6:
        return 'Indicação';
        break;
      case 7:
        return 'Colégio';
        break;
    }
  }
}
